/* eslint-disable indent */
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { DropdownSelectField } from '@jutro/legacy/components';
import { useTranslator } from '@jutro/locale';
import { Flex, FlexItem } from "@jutro/layout";
import { WMICRichTextUtil } from 'wmic-portals-utils-js';
import { WMICClickableIconTooltipComponent } from 'gw-capability-policy-common-react';
import classNames from 'classnames';
import styles from '../WMICRemoveVehicleWizard.module.scss';
import messages from '../WMICRemoveVehicleWizard.messages';
import { getMessageContent } from './index';
import { getVehicleName, getCurrentVehicleIndexByNumber, getElementByXpath, getRemainingDriverVehicle } from '../WMICRemoveVehicleWizardUtils';
import WMICRemoveVehicleMessage from '../../WMICRemoveVehicleMessage/WMICRemoveVehicleMessage';
import { STATE_KEYS, PRIMARY_USE_TEXT, MESSAGE_TYPES, VEHICLE_KEYS, VIEW_KEYS, POLICY_ATTACHMENTS_DRIVERLESS } from '../WMICRemoveVehicleWizardConsts';

import { IntlContext } from '@jutro/legacy/locale';

//List of drivers available except "Unassigned" and "Excluded" drivers.
export const getAvailableDriverstoAssign = (modelState, policy) => {
    const availableDrivers = _.filter(modelState[STATE_KEYS.DRIVERS_TO_ASSIGN], (d) => {
        return policy.currentPeriod.lobs.personalAuto.driverDTOs.find((driver) => (driver?.displayName === d?.name && driver?.assignmentType_WMIC !== 'Unassigned' && driver?.assignmentType_WMIC !== 'Excluded'))
    })
    return availableDrivers;
}

// Verifies that all drivers have been assigned to a vehicle
export const checkPrincipalDriversAssignment = (modelState) => {
    const assignableRemainingVehicles = getRemainingDriverVehicle(modelState[STATE_KEYS.REMAINING_VEHICLES]);
    const uniqAssignedDrivers = _.uniq(_.map(assignableRemainingVehicles, (v) => v.principalDriver));
    const assignedDrivers = _.filter(assignableRemainingVehicles, (v) => v.principalDriver !== undefined);

    return ({
        isPrimaryDriversAssignmentCorrect:
            assignableRemainingVehicles.length <= modelState[STATE_KEYS.DRIVERS_TO_ASSIGN].length
            ? uniqAssignedDrivers.length === assignableRemainingVehicles.length
            : (assignedDrivers.length === assignableRemainingVehicles.length),
        isAtleastOneVehicleAssignedtoDriver: assignableRemainingVehicles.length > modelState[STATE_KEYS.DRIVERS_TO_ASSIGN].length ? uniqAssignedDrivers.length === modelState[STATE_KEYS.DRIVERS_TO_ASSIGN].length : null
    });
};

export const checkPrincipalDriversIsNotEmpty = (modelState) => {
    const assignableRemainingVehicles = getRemainingDriverVehicle(modelState[STATE_KEYS.REMAINING_VEHICLES]);
    return _.some(assignableRemainingVehicles, (v) => !(v.principalDriver));
};

export const setRemainingVehiclesDriverAssignmentError = (modelState, viewStateDispatch, hasClickedContinue) => {
    getRemainingDriverVehicle(modelState[STATE_KEYS.REMAINING_VEHICLES]).forEach((od, idx, array) => { 
        array[idx][VEHICLE_KEYS.ASSIGN_DRIVER_ERROR] = hasClickedContinue === true && (array[idx][VEHICLE_KEYS.PRINCIPAL_DRIVER] === null || array[idx][VEHICLE_KEYS.PRINCIPAL_DRIVER] === undefined);
    });
    viewStateDispatch({type:VIEW_KEYS.HAS_CLICKED_CONTINUE, value: hasClickedContinue});
};

const WMICRemoveVehicleAssignPrimaryDriversStep = (props) => {
    const { modelState, modelStateDispatch, viewState, viewStateDispatch, policy, ...otherProps } = props;
    const translator = useTranslator();
    const checkResult = checkPrincipalDriversAssignment(modelState, policy);
    
    const intl = useContext(IntlContext);
    const getMessage = () => {
        if (viewState[VIEW_KEYS.HAS_CLICKED_CONTINUE] && !checkPrincipalDriversIsNotEmpty(modelState)) {
            if (!checkResult.isPrimaryDriversAssignmentCorrect) {
                if(checkResult.isAtleastOneVehicleAssignedtoDriver === null) {
                    return getMessageContent(MESSAGE_TYPES.PRIMARY_DRIVERS_ASSIGNMENT, translator, intl, modelState, null, null, checkResult)
                } else {
                    return !checkResult.isAtleastOneVehicleAssignedtoDriver ? getMessageContent(MESSAGE_TYPES.ATLEAST_ONE_VEHICLE_ASSIGNED_TO_DRIVER, translator, intl, modelState, null, null, checkResult) : null
                }
            } else if (checkResult.isPrimaryDriversAssignmentCorrect && checkResult.isAtleastOneVehicleAssignedtoDriver !== null && !checkResult.isAtleastOneVehicleAssignedtoDriver) {
                return getMessageContent(MESSAGE_TYPES.ATLEAST_ONE_VEHICLE_ASSIGNED_TO_DRIVER, translator, intl, modelState, null, null, checkResult);
            }
        } else {
            return null;
        }
    }
    const message = getMessage();

    const formattedNumber = (amount) => intl.formatNumber(amount);
    const [firstLoad, setFirstLoad] = useState(true); //used so react redraw due to value change would not trigger reset of focus

    const shouldShowValidationMsg = (vehicle) => vehicle[VEHICLE_KEYS.ASSIGN_DRIVER_ERROR];

    const focusOnFirstValidationMsg = () => {  
        const assignableRemainingVehicles = getRemainingDriverVehicle(modelState[STATE_KEYS.REMAINING_VEHICLES]);
        const validationError = _.some(assignableRemainingVehicles, (v) => shouldShowValidationMsg(v));
        if (validationError) {
            const firstIndexWithError = assignableRemainingVehicles.findIndex(v=>shouldShowValidationMsg(v))
            const driverDropdown = getElementByXpath("//input[contains(@id,'vehicle" + firstIndexWithError + "_primary_drivers_dropdown')]");
            driverDropdown.setAttribute('tabindex', '0');
            driverDropdown.focus({preventScroll: false});
        }
    };
    
    const focusRemoveVehicleAssignPrimaryLabel = () => {
        const headerTag = document.getElementById('WMICRemoveVehicleAssignPrimaryLabel');
        if (headerTag) {
            headerTag.setAttribute('tabindex', '0');
            headerTag.focus({preventScroll: false});
        }
    };

    useEffect(() => {   
        if (firstLoad) {
            setFirstLoad(false);
            viewStateDispatch({type:VIEW_KEYS.HAS_CLICKED_CONTINUE, value: false});
            focusRemoveVehicleAssignPrimaryLabel();
        }
        focusOnFirstValidationMsg();
    });

    const getVehicleNameWithWarning = (vehicle) => {
        return translator(messages.assignDriversValidationAriaWarningMessage,{vehicle:getVehicleName(vehicle)});
    }

    return (
        <div {...otherProps}>
            {message && <WMICRemoveVehicleMessage {...message} />}
            <p className={classNames('mb-6', styles['wmic-edit-title'])}>
                <div className={styles['assign-drivers-title']} id="WMICRemoveVehicleAssignPrimaryLabel">
                    {WMICRichTextUtil.translateRichText(translator(messages.assignPrimaryDriversMessage))}
                    <span className={styles.wmicTooltipContainer}>
                        <WMICClickableIconTooltipComponent
                            tooltipMessage={translator(messages.assignPrimaryDriversToTheVehicleToolTip)}
                            placement="top"
                        />
                    </span>
                </div>
                <div className={styles['assign-drivers-title']}>
                    {WMICRichTextUtil.translateRichText(translator(messages.assignDriversCallMessage))}
                </div>
            </p>

            <Flex className={styles.wmicFlexContainer} role='list'>
                {
                    _.map(getRemainingDriverVehicle(modelState[STATE_KEYS.REMAINING_VEHICLES]), (vehicle, idx) => (
                        <div className={styles.wmicFlexColumn} role='listitem'>
                            <FlexItem grow={1} className={styles.wmicBox}>
                                <div className={styles.wmicBoxContent} key={idx}>
                                    <h3 data-di-unmask-field htmlFor={`driver${idx}`}>
                                        <span className={styles.wmicStrong}>{getVehicleName(vehicle)}</span>
                                    </h3>
                                    <DropdownSelectField
                                        id={`vehicle${idx}_primary_drivers_dropdown`}
                                        className={classNames('field py-4')}
                                        label={shouldShowValidationMsg(vehicle)?getVehicleNameWithWarning(vehicle):getVehicleName(vehicle)}
                                        labelClassName={styles['wmicHidden']}
                                        availableValues={getAvailableDriverstoAssign(modelState, policy)}
                                        value={vehicle.principalDriver}
                                        placeholder={translator(messages.assignDriversPleaseSelect)}
                                        onValueChange={(v) => {
                                            const vehicleIdx = getCurrentVehicleIndexByNumber(vehicle.vehicleNumber, modelState[STATE_KEYS.REMAINING_VEHICLES]);
                                            modelStateDispatch({ type: `${STATE_KEYS.REMAINING_VEHICLES}.${vehicleIdx}.principalDriver`, value: v });
                                            setRemainingVehiclesDriverAssignmentError(modelState, viewStateDispatch, false);
                                        }}
                                    />
                                    <div className={shouldShowValidationMsg(vehicle) ? cx(styles.wmicInputBoxNotes, styles.errorRed) : styles['wmicHidden']} >
                                        {translator(messages.assignDriversValidationMessage)} 
                                    </div>

                                    <div className="pb-4">
                                        <p>
                                            <strong>{translator(messages.use)}</strong> {PRIMARY_USE_TEXT[vehicle.primaryUse]}
                                        </p>
                                        <p>
                                            <strong>{translator(messages.annualMileage)}</strong> {formattedNumber(vehicle.annualMileage)}
                                        </p>
                                    </div>
                                </div>
                            </FlexItem>
                        </div>
                        )
                    )
                }
            </Flex>
        </div>
    );
}

WMICRemoveVehicleAssignPrimaryDriversStep.propTypes = {
    modelState: PropTypes.shape({}).isRequired,
    modelStateDispatch: PropTypes.func.isRequired
};

export default WMICRemoveVehicleAssignPrimaryDriversStep;
